/**
 * Query keys — единый источник правды для TanStack Query.
 *
 * Структура: иерархическая, чтобы можно было точечно инвалидировать.
 * См. https://tanstack.com/query/latest/docs/framework/react/guides/query-keys.
 */

export type MembersFilters = {
  q?: string;
  segment_id?: string[];
  state?: Array<'active' | 'churned' | 'frozen' | 'lead' | 'other'>;
  zone?: Array<'red' | 'yellow' | 'green'>;
  curator_name?: string[];
  industry_id?: number[];
  has_forum?: boolean;
  join_year_from?: number;
  join_year_to?: number;
  limit?: number;
  offset?: number;
  sort?: string;
};

export const queryKeys = {
  members: {
    all: ['members'] as const,
    list: (filters: MembersFilters) => ['members', 'list', filters] as const,
    detail: (id: number) => ['members', 'detail', id] as const,
    narrative: (id: number) => ['members', 'narrative', id] as const,
    timeseries: (id: number) => ['members', 'timeseries', id] as const,
    today: (limit?: number) => ['members', 'today', limit ?? 15] as const,
  },
  segments: {
    all: ['segments'] as const,
    list: () => ['segments', 'list'] as const,
    detail: (id: string) => ['segments', 'detail', id] as const,
    members: (id: string, state?: string, limit?: number) =>
      ['segments', 'members', id, state ?? 'active', limit ?? 50] as const,
  },
  club: {
    barometer: () => ['club', 'barometer'] as const,
    angels: () => ['club', 'angels'] as const,
    cohorts: () => ['club', 'cohorts'] as const,
    predictors: () => ['club', 'predictors'] as const,
    hobbyRetention: () => ['club', 'hobby-retention'] as const,
    forumRetention: () => ['club', 'forum-retention'] as const,
    retentionModel: () => ['club', 'retention-model'] as const,
    declarationVsLife: () => ['club', 'declaration-vs-life'] as const,
    energyMap: () => ['club', 'energy-map'] as const,
    distribution: () => ['club', 'distribution'] as const,
  },
  curators: {
    list: (minN: number) => ['curators', 'list', minN] as const,
  },
  ai: {
    suggestions: () => ['ai', 'suggestions'] as const,
  },
  adminUsers: {
    all: ['admin', 'users'] as const,
    list: () => ['admin', 'users', 'list'] as const,
  },
} as const;
